<template>
  <div class="cloub_booth">

    <div v-if="meeting_data&&meeting_data.back_menu_type" style="height:44px;"></div>

    <div class="bgc_img">
      <img :src="meeting_data.background_img_path" alt="">
    </div>

    <div class="head_img">
      <img width="100%" :src="meeting_data.video_img_path" alt="">
    </div>

    <div class="contentBox">

      <div v-if="page_id==145" class="title_imgS">
        <img src="@/assets/主席致辞@2x (3).png" alt="">
      </div>

      <div v-if="page_id!=145" class="title_img">
        <img v-if="video_data.poster_path" :src="video_data.poster_path" alt="">
        <img v-if="!video_data.poster_path" src="@/assets/编组 9@2x (8).png" alt="">
      </div>

      <div :class="{dataBoxB :page_id==145}" class="dataBox">

        <div class="logo">
          <img width="100%" :src="video_data.tag_log_path" alt="">
        </div>

        <div v-if="video_data.live_link" class="videoBox">
          <video controls="controls" preload="auto" webkit-playsinline="" playsinline="" x-webkit-airplay="allow"
            x5-playsinline="true" :poster="video_data.cover_path" class="video" :src="video_data.live_link"></video>
        </div>

        <div class="video_message">
          <viewer :images='[video_data.content]'>
            <p class="bigImg" v-html="video_data.content"></p>
          </viewer>
        </div>

      </div>
    </div>

    <!-- <div class="end_img">
      <img height="16px"
        src="http://meeting.xoncology.com/storage/app/setmeet/2024-04/wrtpfmyooAV7a40fqfamLmGQ7aH759BocDZCovUY.png"
        alt="">
    </div> -->

    <backhome v-if="meeting_data&&meeting_data.back_menu_type" :baseData='meeting_data' :meeting_data='meeting_data'>
    </backhome>
  </div>
</template>

<script>
import { geiYunDetail, geiVideodetail } from "@/api/meetApi.js";
import { getWXConfig } from "@/api/login.js";
import backhome from '@/components/backHome.vue';
export default {
  components: { backhome },
  data() {
    return {
      page_id: '',
      meeting_data: {},
      video_data: {},
      baseData: {},
    }
  },
  async created() {
    console.log(45678)
    this.page_id = this.$route.query.id
    let data = await geiVideodetail({ id: this.$route.query.id, meeting_id: this.$route.query.meeting_id })
    this.meeting_data = data.payload.meeting_data
    console.log(this.meeting_data)
    this.video_data = data.payload.data
  },
  method: {

  }
}
</script>

<style scoped>
.title_img img {
  width: 100%;
  position: relative;
  left: 0%;
  margin-top: 17px;
}
.title_imgS {
  text-align: center;
  margin-bottom: 12px;
  position: relative;
  top: -20px;
}
.title_imgS img {
  width: 124px;
}
:deep(.bigImg img) {
  width: 100% !important;
  height: unset;
}
.bgc_img {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
  max-width: 768px;
  margin: auto;
}
.bgc_img img {
  width: 100%;
  height: 100%;
}
.cloub_booth {
  width: 100%;
  min-height: 100vh;
}
.contentBox {
  padding: 0 8px;
}
.video,
.videoBox {
  background-color: black;
  width: 100%;
  height: 56.7vw;
  max-width: 768px;
  max-height: 436px;
  margin-bottom: 12px;
  border-radius: 8px;
}
.dataBox {
  /* border: 1px solid #eecc9d; */
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  padding: 16px;
  position: relative;
  top: -2.3vw;
  overflow: hidden;
}
.dataBoxB {
  border-radius: 8px;
  overflow: hidden; 
  top: -20px;
}
.logo {
  margin-bottom: 12px;
}
.video_message {
  overflow: hidden;
  border-radius: 8px;
}
.end_img {
  text-align: center;
  padding: calc(24px - 2.3vw) 0 24px 0;
}
@media screen and (min-width: 768px) {
  .dataBox {
    top: -18px;
  }
  .end_img {
    padding: 0 0 24px 0;
  }
}
</style>